"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));

var _ExpansionPanelSummary = _interopRequireDefault(require("@material-ui/core/ExpansionPanelSummary"));

var _ExpansionPanelDetails = _interopRequireDefault(require("@material-ui/core/ExpansionPanelDetails"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '& .MuiExpansionPanelSummary-root': {
        display: 'inline-flex',
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1)
      },
      '& .MuiExpansionPanelSummary-root.Mui-expanded': {
        minHeight: 48
      },
      '& .MuiExpansionPanelSummary-content.Mui-expanded': {
        margin: 0,
        fontSize: 16,
        fontWeight: 500
      },
      '& .MuiExpansionPanelSummary-content': {
        fontSize: 16,
        fontWeight: 500
      },
      '& .MuiExpansionPanelSummary-expandIcon.Mui-expanded': {}
    },
    detail: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0
    },
    panel: {
      width: '100%'
    },
    list: {
      display: 'flex',
      paddingTop: 0,
      paddingBottom: 0
    }
  };
}, {
  name: 'SelectMultipleExpandField'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null);

function SelectMultipleExpandField(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "label", "onChange", "options", "value"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var handleChange = _react.default.useCallback(function (v) {
    return function () {
      var vv = value || [];
      var i = vv.indexOf(v);
      var nextV = i >= 0 ? [].concat((0, _toConsumableArray2.default)(vv.slice(0, i)), (0, _toConsumableArray2.default)(vv.slice(i + 1))) : [].concat((0, _toConsumableArray2.default)(vv), [v]);
      onChange(nextV);
    };
  }, [onChange, value]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_ExpansionPanel.default, {
    elevation: 0,
    defaultExpanded: true,
    square: true,
    className: classes.panel
  }, /*#__PURE__*/_react.default.createElement(_ExpansionPanelSummary.default, {
    expandIcon: _ref2,
    IconButtonProps: {
      color: 'primary'
    }
  }, t(label, {
    acceptString: true
  })), /*#__PURE__*/_react.default.createElement(_ExpansionPanelDetails.default, {
    className: classes.detail
  }, options.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      key: index.toString(),
      onClick: handleChange(i.value),
      className: classes.list
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      color: "primary",
      checked: Boolean(value && value.indexOf(i.value) >= 0)
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, null, t(i.label, {
      acceptString: true
    }), " (", i.count, ")"));
  }))));
}

process.env.NODE_ENV !== "production" ? SelectMultipleExpandField.propTypes = {
  classes: _propTypes.default.shape({
    detail: _propTypes.default.string,
    list: _propTypes.default.string,
    panel: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.shape({}))])
} : void 0;
SelectMultipleExpandField.defaultProps = {
  classes: undefined,
  className: undefined,
  label: undefined,
  value: undefined
};
var _default = SelectMultipleExpandField;
exports.default = _default;